import { useState } from 'react';
const useCustomHook = () => {
  const [deleting, setDeleting] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [thumbnailIsLoaded, setThumbnailIsLoaded] = useState(false);

  return {
    deleting, setDeleting,
    confirmDeleteModal, setConfirmDeleteModal,
    thumbnailIsLoaded, setThumbnailIsLoaded
  };
};

export default useCustomHook;
